import type { DeepPartial } from '@luna/utils-ts';

import type { OverviewFeatureConfig } from './type';

export const overview: DeepPartial<OverviewFeatureConfig> = {
    birthdayGreeting: {
        isGeneralConsentRequired: true,
        isMarketingConsentRequired: true,
    },
    products: {
        currentAccount: {
            secondaryAmount: 'disposable',
        },
        buildingSociety: {
            saving: {
                showMonthlyContribution: true,
                showProgress: true,
                showTargetAmount: true,
            },
        },
    },
};
